export class ContactUsModel{
    Name: string;
    Email: string;
    Subject: string;
    Content: string;
}
